declare let ValueText: any;

declare global {
  interface Window {
    ValueText: any;
  }
}

const fontPrefix = '';
let replacementFont;

export function extendValueText() {
  if (lib.comsuntexsymbolsValueText) {
    window.ValueText = lib.comsuntexsymbolsValueText;
    replacementFont = 'Suntex';
  }

  if (lib.comsuntexsymbolsValueTextSerif) {
    window.ValueText = lib.comsuntexsymbolsValueTextSerif;
    replacementFont = 'Suntex';
  }

  if (lib.comsuntexsymbolsValueTextBlack) {
    window.ValueText = lib.comsuntexsymbolsValueTextBlack;
    //fontPrefix = "bold ";
    replacementFont = 'Open Sans Condensed';
  }

  if (window.ValueText && !window.ValueText.prototype._oldConstructor) {
    const oldConstructor = window.ValueText;
    const oldPrototype = window.ValueText.prototype;

    const p = ((window.ValueText = function () {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      (this as any)._oldConstructor();
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      (this as any)._newConstructor();
    }).prototype = oldPrototype);

    if (lib.comsuntexsymbolsValueText) {
      lib.comsuntexsymbolsValueText = window.ValueText;
    }
    if (lib.comsuntexsymbolsValueTextSerif) {
      lib.comsuntexsymbolsValueTextSerif = window.ValueText;
    }
    if (lib.comsuntexsymbolsValueTextBlack) {
      lib.comsuntexsymbolsValueTextBlack = window.ValueText;
    }

    p._oldConstructor = oldConstructor;

    p._newConstructor = function () {
      this.fixFont(this.fields.largeText);
      this.fixFont(this.fields.smallText);
      this.fixFont(this.fields.tinyText);
      this.fixFont(this.fields.extraTinyText);
      this.fixFont(this.fields.numerator);
      this.fixFont(this.fields.denominator);

      this.shrink = 0;
      this.value = null;
      this.minShrink = 0;
      this.lockSize = false;
      this.clear();
      UIUtil.disable(this);
      ValueText.instances.push(this);
    };

    p.fixFont = function (textField) {
      textField.font =
        fontPrefix +
        textField.font
          .replace('Tahoma', ValueText.font)
          .replace('Arial', ValueText.font);
    };

    p.clear = function () {
      this.fields.largeText.text = '';
      this.fields.smallText.text = '';
      this.fields.tinyText.text = '';
      this.fields.extraTinyText.text = '';
      this.fields.numerator.text = '';
      this.fields.denominator.text = '';
      this.fields.line.alpha = 0.0;
      this.clearGlow();
    };

    p.blacken = function () {
      this.fields.largeText.color = '#000';
      this.fields.smallText.color = '#000';
      this.fields.tinyText.color = '#000';
      this.fields.extraTinyText.color = '#000';
      this.fields.numerator.color = '#000';
      this.fields.denominator.color = '#000';
      UIUtil.setFrame(this.fields.line, 1);
    };

    p.whiten = function () {
      this.fields.largeText.color = '#FFF';
      this.fields.smallText.color = '#FFF';
      this.fields.tinyText.color = '#FFF';
      this.fields.extraTinyText.color = '#FFF';
      this.fields.numerator.color = '#FFF';
      this.fields.denominator.color = '#FFF';
      UIUtil.setFrame(this.fields.line, 2);
    };

    p.setColor = function (newColor) {
      this.fields.largeText.color = newColor;
      this.fields.smallText.color = newColor;
      this.fields.tinyText.color = newColor;
      this.fields.extraTinyText.color = newColor;
      this.fields.numerator.color = newColor;
      this.fields.denominator.color = newColor;

      //UIUtil.setFrame(this.fields.line, 2);
    };

    p.smallerText = function () {
      this.minShrink = 1;
    };

    p.displayText = function (text, shrink) {
      if (shrink == null) shrink = 0;
      this._setFieldText(text, shrink);
    };

    p.displayValue = function (value, shrink) {
      if (shrink == null) shrink = 0;
      this.value = value;
      if (value != null) {
        if (Calculator.isFraction(value)) {
          this.displayFraction(value);
        } else {
          this.displayDecimal(value, shrink);
        }
      } else {
        this.clear();
      }
    };

    p.displayDecimal = function (number, shrink) {
      if (shrink == null) shrink = 0;
      number = Math.round(number * 10000) / 10000;
      const numDigits = ValueText.getDigitCount(number);
      shrink = Math.max(shrink, numDigits - 1);
      shrink = Calculator.bound(shrink, this.minShrink, 3);

      this._setFieldText('' + number, shrink);
    };

    p.displayFraction = function (fraction, shrink) {
      if (shrink == null) shrink = 0;
      this.clear();
      if (fraction[1] == 1) {
        this.displayDecimal(fraction[0]);
      } else {
        this.fields.numerator.text = '' + fraction[0];
        this.fields.denominator.text = '' + fraction[1];
        this.fields.line.alpha = 1.0;
      }
    };

    p.displayFractionWithoutLine = function (fraction, shrink) {
      if (shrink == null) shrink = 0;
      this.clear();
      if (fraction[1] == 1) {
        this.displayDecimal(fraction[0]);
      } else {
        this.fields.numerator.text = '' + fraction[0];
        this.fields.denominator.text = '' + fraction[1];
      }
    };

    p.glow = function () {
      this.textGlow.alpha = 1.0;
    };

    p.clearGlow = function () {
      this.textGlow.alpha = 0.0;
    };

    p._setFieldText = function (text, shrink) {
      this.shrink = shrink;
      this.clear();

      let textField;
      switch (this.lockSize ? 0 : this.shrink) {
        case 3:
          textField = this.fields.extraTinyText;
          break;
        case 2:
          textField = this.fields.tinyText;
          break;
        case 1:
          textField = this.fields.smallText;
          break;
        default:
          textField = this.fields.largeText;
          break;
      }
      textField.text = text;
    };

    /* Static */

    ValueText.instances = [];

    ValueText.font = replacementFont;

    ValueText.makeFontSizeConsistent = function (valueTextInstances) {
      if (valueTextInstances == null) valueTextInstances = ValueText.instances;

      const shrink = ArrayUtil.max(valueTextInstances, 'shrink');

      TestUtil.log(shrink);

      for (let i = 0; i < valueTextInstances.length; i++) {
        if (valueTextInstances[i].value !== null) {
          valueTextInstances[i].displayValue(
            valueTextInstances[i].value,
            shrink,
          );
        }
      }
    };

    ValueText.getDigitCount = function (number) {
      return this.getRegExpCount('' + number, /[\-0-9]/);
    };

    ValueText.getRegExpCount = function (str, regexp) {
      return str.split(regexp).length - 1;
    };
  }
  const cache = {};
  if (createjs.TweenJS.version != 'NEXT') {
    //Prevent this from running on SS Games Using Older Library.
    (createjs.Text.prototype as any)._drawTextLine = function (ctx, text, y) {
      this.textBaseline = ctx.textBaseline = 'alphabetic';
      if (!(this.font in cache)) {
        const metrics = this.getMetrics();
        cache[this.font] = metrics.vOffset;
      }
      const offset = cache[this.font];
      if (this.outline) {
        ctx.strokeText(text, 0, y - offset, this.maxWidth || 0xffff);
      } else {
        ctx.fillText(text, 0, y - offset, this.maxWidth || 0xffff);
      }
    };
  }
}
